import type { CategorizationRule, KeywordMapping } from '../types';

export const RULES: CategorizationRule[] = [
  {
    category: "Personal Care",
    keywords: [
      "great clips",
      "supercuts",
      "sport clips",
      "fantastic sams",
      "hair salon",
      "barber shop",
      "barber",
      "nail salon",
      " spa",
      "massage",
      "facial",
      "waxing",
      "tanning",
      "salon",
      "ulta",
      "nails",
      "drybar",
      "european wax",
      "laseraway",
      "sephora",
    ],
  },
  {
    category: "Healthcare",
    keywords: [
      "pharmacy",
      "cvs",
      "walgreens",
      "rite aid",
      "duane reade",
      "doctor",
      "hospital",
      "medical",
      "dental",
      "dentist",
      "pediatric",
      "clinic",
      "urgent care",
      "orthodont",
      "eye care",
      "vision center",
      "optometry",
      " eye ",
      "counseling",
      "therapy",
      // Removed "med " - too generic, matches "redeemed", "remedies", etc.
      "quest diagnostics",
      "labcorp",
      "derm",
      "advocate",
      "minute clinic",
      "cvs minute",
      "teladoc",
      "mdlive",
    ],
  },
  {
    category: "Health & Fitness",
    keywords: [
      "ymca",
      "shred415",
      "elite sports complex",
      "icp*elite",
      "wellbrooke",
      "fitness",
      // Removed "gym" - too generic and causes false matches with "gymnastics"
      "planet fitness",
      "la fitness",
      "24 hour fitness",
      "anytime fitness",
      "orangetheory",
      "crossfit",
      "equinox",
      "lifetime fitness",
      "crunch fitness",
    ],
  },
];

export const DISPLAY_NAMES: KeywordMapping[] = [
  { keyword: "cvs", displayName: "CVS" },
  { keyword: "walgreens", displayName: "Walgreens" },
  { keyword: "great clips", displayName: "Great Clips" },
  { keyword: "ulta", displayName: "Ulta Beauty" },
  { keyword: "sephora", displayName: "Sephora" },
  { keyword: "planet fitness", displayName: "Planet Fitness" },
  { keyword: "la fitness", displayName: "LA Fitness" },
  { keyword: "orangetheory", displayName: "Orangetheory" },
];
